import { ActionControllerEventName, ParentEvent, ResourcesManager, Tween, Viewer, ViewerModule } from '@verybigthings/vbt-webvr-framework';
import { ConeGeometry, CylinderGeometry, Euler, Mesh, MeshBasicMaterial, Object3D, Quaternion, Vector3 } from 'three';
import IconButtonComponent from '@verybigthings/vbt-webvr-framework/build/main/ts/components/IconButtonComponent';
import * as styleConfig from '../../styleConfig';
import { PickingControllerEvents } from '@verybigthings/vbt-webvr-framework/build/main/ts/controls/PickingController';
import { PreparationPickingObjects } from "../../utils/PreparationPickingObjects";
export default class SerologicalPipetteModule extends ViewerModule {
    constructor(level) {
        super();
        this.__inited = false;
        this.uiObject.name = 'Serological_PIPETTE_MODULE';
        this.pointerController = Viewer.pointerController;
        this.model = ResourcesManager.getModel('serological_pipette_5').clone();
        this.addObject(this.model);
        this.buttonPlus = this.model.getObjectByName('button1');
        this.buttonMinus = this.model.getObjectByName('button2');
        this.water = new Object3D();
        this.water.position.set(.97, 0, 0);
        this.addObject(this.water);
        this.level = level;
    }
    init() {
        this.pointerController.setObject(null);
        this.uiObject.scale.set(1, 1, 1);
        this.model.position.set(0, 0, 0);
        this.water.position.set(.97, 0, 0);
        this.level.instruments.pipetteHolder.uiObject.add(this.uiObject);
        this.uiObject.rotation.set(-.36, Math.PI / 2, 0);
        this.uiObject.position.set(0, .34, -.02);
        PreparationPickingObjects.saveObjectState(this.uiObject);
    }
    updateModel(modelName) {
        this.model.parent.remove(this.model);
        this.model = ResourcesManager.getModel(modelName).clone();
        this.addObject(this.model);
        this.buttonPlus = this.model.getObjectByName('button1');
        this.buttonMinus = this.model.getObjectByName('button2');
        this.addToPointer();
    }
    addToHolder() {
        this.pointerController.setObject(null);
        this.uiObject.scale.set(1, 1, 1);
        this.model.position.set(0, 0, 0);
        this.water.position.set(.97, 0, 0);
        ResourcesManager.getAudioManger().getAudio('put_sound').play();
        this.level.instruments.pipetteHolder.uiObject.add(this.uiObject);
        this.uiObject.rotation.set(-.36, Math.PI / 2, 0);
        this.uiObject.position.set(0, .34, -.02);
        // this.uiObject.position.set(.5, .16, .34);
    }
    addToPointer() {
        this.water.position.set(.01, 1.25, 0);
        this.model.position.set(-.96, 1.25, 0);
        if (Viewer.controls.zController)
            return;
        this.uiObject.add(this.model);
        this.uiObject.rotation.set(0, 0, 0);
        this.uiObject.position.set(0, 0, 0);
        this.pointerController.setObject(this.uiObject);
        // attachTransformControls( this.model);
    }
    createClickEvent() {
        let callback;
        this.actionController.on(ActionControllerEventName.click, this.uiObject, callback = () => {
            if (!this.level.interaction)
                return;
            this.fire('pipette_clicked');
            this.actionController.off(ActionControllerEventName.click, this.uiObject, callback);
        });
    }
    tweenAnimation(model, newPosition, newRotation, duration, onComplete) {
        const oldPos = model.position.clone();
        const oldRotation = new Quaternion().setFromEuler(model.rotation.clone());
        const newPos = newPosition;
        const newRot = new Quaternion();
        newRot.setFromEuler(newRotation);
        const tween = new Tween({ alpha: 0 }).to({ alpha: 1 }, duration || 1000)
            .onUpdate((alpha) => {
            const currentPos = oldPos.clone().lerp(newPos, alpha);
            Quaternion.slerp(oldRotation, newRot, model.quaternion, alpha);
            model.position.copy(currentPos);
        })
            .onComplete(onComplete ? onComplete : () => {
        })
            .start();
        return tween;
    }
    initFilling() {
        this.pointerController.setObject(null);
        this.uiObject.scale.set(1, 1, 1);
        this.model.position.set(0, 0, 0);
        this.water.position.set(.97, 0, 0);
        this.uiObject.position.set(-.98, -.7, 3.5);
        this.uiObject.rotation.set(0, 0, 0);
        this.level.uiContainerObjects.add(this.uiObject);
        this.tweenAnimation(this.uiObject, new Vector3(-.98, -1.27, 3.5), new Euler(0, 0, 0), 1000, () => this.fire('ready_to_fill'));
    }
    startFilling(volume) {
        let callbackPlus;
        let callbackMinus;
        this.water = new Object3D();
        this.water.position.set(.97, 0, 0);
        this.addObject(this.water);
        const cone = new Mesh(new ConeGeometry(.06, .1, 16), new MeshBasicMaterial({ color: 'red' }));
        cone.rotation.set(Math.PI, 0, 0);
        cone.position.set(0, -1.156, 0);
        this.water.add(cone);
        this.waterLevel = new Mesh(new CylinderGeometry(.06, .06, .1, 16), new MeshBasicMaterial({ color: 'red' }));
        this.waterLevel.position.set(0, -1.056, 0);
        this.water.add(this.waterLevel);
        this.actionController.on(ActionControllerEventName.buttonDown, this.buttonPlus, callbackPlus = () => {
            if (!this.level.interaction)
                return;
            this.controls.enabled = false;
            const interval = setInterval(() => {
                if (this.waterLevel.scale.y <= 13) {
                    this.waterLevel.scale.y += .2;
                    this.waterLevel.position.y += .01;
                }
            }, 100);
            const tween = this.tweenAnimation(this.buttonPlus, new Vector3(-.16, 0, 0), new Euler(0, 0, 0), 300);
            let unPlus;
            this.actionController.once(ActionControllerEventName.buttonUp, this.buttonPlus, unPlus = () => {
                this.controls.enabled = true;
                tween.stop();
                clearInterval(interval);
                this.tweenAnimation(this.buttonPlus, new Vector3(0, 0, 0), new Euler(0, 0, 0), 300);
            });
            if (Viewer.zSpaceControls && Viewer.controls.zController)
                Viewer.zSpaceControls.once('buttonLeftUp', unPlus);
        });
        if (Viewer.zSpaceControls && Viewer.controls.zController)
            Viewer.zSpaceControls.on('buttonLeftDown', callbackPlus);
        this.actionController.on(ActionControllerEventName.buttonDown, this.buttonMinus, callbackMinus = () => {
            if (!this.level.interaction)
                return;
            this.controls.enabled = false;
            const interval = setInterval(() => {
                if (this.waterLevel.scale.y >= 1) {
                    this.waterLevel.scale.y -= .6;
                    this.waterLevel.position.y -= .03;
                }
            }, 100);
            const tween = this.tweenAnimation(this.buttonMinus, new Vector3(-.13, 0, 0), new Euler(0, 0, 0), 300);
            let unMinus;
            this.actionController.once(ActionControllerEventName.buttonUp, this.buttonMinus, unMinus = () => {
                this.controls.enabled = true;
                tween.stop();
                clearInterval(interval);
                this.tweenAnimation(this.buttonMinus, new Vector3(0, 0, 0), new Euler(0, 0, 0), 300);
            });
            if (Viewer.zSpaceControls && Viewer.controls.zController)
                Viewer.zSpaceControls.once('buttonRightUp', unMinus);
        });
        if (Viewer.zSpaceControls && Viewer.controls.zController)
            Viewer.zSpaceControls.on('buttonRightDown', callbackMinus);
        const okButton = new IconButtonComponent({
            diameter: .6,
            text: '',
            textColor: styleConfig.BUTTON_PRIMARY_TEXT_COLOR.getStyle(),
            background: styleConfig.BUTTON_PRIMARY_COLOR.getStyle()
        });
        okButton.uiObject.position.set(.4, .45, 0);
        this.addObject(okButton);
        okButton.on('click', () => {
            if (!this.level.interaction)
                return;
            if (volume === 5 && (this.waterLevel.scale.y >= 7 && this.waterLevel.scale.y <= 8) ||
                volume === 3 && (this.waterLevel.scale.y >= 3.4 && this.waterLevel.scale.y <= 4.4) ||
                volume === 8 && (this.waterLevel.scale.y >= 12.2 && this.waterLevel.scale.y <= 13.2)) {
            }
            else {
                this.fire('not_full', new ParentEvent('not_full', {
                    tooMuch: (volume === 5 && this.waterLevel.scale.y > 8 ||
                        volume === 3 && this.waterLevel.scale.y > 4.4 ||
                        volume === 8 && this.waterLevel.scale.y > 13.2)
                }));
                ResourcesManager.getAudioManger().getAudio('fail_sound').play();
            }
            this.fire('pipette_full');
            this.actionController.off(ActionControllerEventName.buttonDown, this.buttonPlus, callbackPlus);
            this.actionController.off(ActionControllerEventName.buttonDown, this.buttonMinus, callbackMinus);
            if (Viewer.zSpaceControls && Viewer.controls.zController) {
                Viewer.zSpaceControls.off('buttonRightDown', callbackMinus);
                Viewer.zSpaceControls.off('buttonLeftDown', callbackPlus);
            }
            okButton.dispose();
            if (this.level.lobby.app.zSpacePickingController) {
                PreparationPickingObjects.saveObjectState(this.uiObject);
                // zSpacePickingController ======
                this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.PICKED, this.uiObject, () => {
                    if (!this.level.interaction)
                        return;
                    Viewer.scene.add(this.uiObject);
                    this.level.lobby.app.zSpacePickingController.on(PickingControllerEvents.RELEASED, this.uiObject, () => {
                        const distanceToJar = this.level.instruments.pipette.model.getWorldPosition(new Vector3()).distanceTo(this.level.instruments.jar.model.getWorldPosition(new Vector3()));
                        if (distanceToJar < 1.6) {
                            this.fire('holder_clicked');
                            this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.PICKED, this.uiObject);
                            this.level.lobby.app.zSpacePickingController.off(PickingControllerEvents.RELEASED, this.uiObject);
                        }
                        else {
                            PreparationPickingObjects.flyObjectToPrevState(this.uiObject, 0);
                        }
                        setTimeout(() => this.uiObject.traverse(el => {
                            if (el.userData.oldRaycast)
                                el.raycast = el.userData.oldRaycast;
                        }));
                    });
                });
            }
        });
    }
    initDevastation(stepIndex) {
        this.pointerController.setObject(null);
        this.uiObject.scale.set(1, 1, 1);
        const stepX = stepIndex === 1 ? -.5 : stepIndex === 2 ? 0 : .5;
        this.model.position.set(0, 0, 0);
        this.water.position.set(.97, 0, 0);
        this.uiObject.position.set(1.27 + stepX, -1.577, -.42);
        this.uiObject.rotation.set(0, 0, 0);
        this.level.uiContainerObjects.add(this.uiObject);
        this.tweenAnimation(this.uiObject, new Vector3(1.27 + stepX, -2.25, -.42), new Euler(0, 0, 0), 1000, () => this.fire('ready_to_devastate'));
    }
    startDevastation() {
        let callbackMinus;
        let empty = false;
        const startingLevel = this.waterLevel.scale.y <= 4.4 ? 3 : this.waterLevel.scale.y <= 8 ? 5 : 8;
        this.actionController.on(ActionControllerEventName.buttonDown, this.buttonMinus, callbackMinus = () => {
            if (!this.level.interaction)
                return;
            this.controls.enabled = false;
            const interval = setInterval(() => {
                if (this.waterLevel.scale.y >= .1) {
                    this.waterLevel.scale.y -= .6;
                    this.waterLevel.position.y -= .03;
                }
                else {
                    this.disposeObject(this.water);
                    this.fire('pipette_empty', new ParentEvent('pipette_empty', { waterLevel: startingLevel }));
                    empty = true;
                }
            }, 100);
            const tween = this.tweenAnimation(this.buttonMinus, new Vector3(-.13, 0, 0), new Euler(0, 0, 0), 300);
            let unMinus;
            this.actionController.once(ActionControllerEventName.buttonUp, this.buttonMinus, unMinus = () => {
                this.controls.enabled = true;
                tween.stop();
                clearInterval(interval);
                this.tweenAnimation(this.buttonMinus, new Vector3(0, 0, 0), new Euler(0, 0, 0), 300);
            });
            if (Viewer.zSpaceControls && Viewer.controls.zController)
                Viewer.zSpaceControls.once('buttonRightUp', unMinus);
        });
        if (Viewer.zSpaceControls && Viewer.controls.zController)
            Viewer.zSpaceControls.on('buttonRightDown', callbackMinus);
        const okButton = new IconButtonComponent({
            diameter: .9,
            text: '',
            textColor: styleConfig.BUTTON_PRIMARY_TEXT_COLOR.getStyle(),
            background: styleConfig.BUTTON_PRIMARY_COLOR.getStyle()
        });
        okButton.uiObject.position.set(.4, .25, 0);
        this.addObject(okButton);
        okButton.on('click', () => {
            if (!this.level.interaction)
                return;
            if (empty) {
                PreparationPickingObjects.saveObjectState(this.uiObject);
                this.fire('pipette_empty_button');
                this.actionController.off(ActionControllerEventName.buttonDown, this.buttonMinus, callbackMinus);
                if (Viewer.zSpaceControls && Viewer.controls.zController)
                    Viewer.zSpaceControls.off('buttonRightDown', callbackMinus);
                okButton.dispose();
            }
            else {
                // this.fire('not_empty');
                ResourcesManager.getAudioManger().getAudio('fail_sound').play();
            }
        });
    }
}
